import Helper from "./Helper";

class HeaderSingleImageAnimation {
  constructor(config = {}) {
    const {
      selector,
    } = config;
    this.selector = selector;
    this.imageItem = document.querySelector(this.selector);

    if (this.imageItem != null) {
      this.bindEvents();
    }
  }

  bindEvents() {
    Helper.addClass(this.imageItem, 'zoom-in')
  }
}

export default HeaderSingleImageAnimation;
